var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ChooseShopItemModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-306e129c!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChooseShopItemModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/ChooseShopItemModal.vue
// module id = 697
// module chunks = 0